import { render, staticRenderFns } from "./Hooks.vue?vue&type=template&id=6629b15c"
import script from "./Hooks.vue?vue&type=script&lang=js"
export * from "./Hooks.vue?vue&type=script&lang=js"
import style0 from "./Hooks.vue?vue&type=style&index=0&id=6629b15c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports